import { ref } from 'vue'
import AuthLogin from '@/components/auth/parts/steps/AuthLogin.vue'

const loginSteps = ref([
    {
        identifier: 'login-welcome',
        titles: ['Log in'],
        component: AuthLogin
    }
])

export const useLoginSteps = () => {
    return { loginSteps }
}
